import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import {
  renderField,
  required,
  renderTextArea,
  number,
  renderPass,
  renderToggle,
  renderSelectField,
  renderPassTextArea,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm, formValueSelector, getFormValues, getFormInitialValues } from "redux-form";
import { withRouter } from "react-router-dom";
import {withTranslation} from "react-i18next";
import { Button, FormFooter, Groups, FormField } from "../../../../components/Form"

class ProxmoxProviderFormTemplate extends Component {

  constructor(props) {
    super(props);
    this.state = {
      currentProvider: {},
    };
    this.submitApi = this.submitApi.bind(this);
    this.cancelButton = this.cancelButton.bind(this);
    this.updateFullClone = this.updateFullClone.bind(this);
  }

  componentDidMount() {

    let newValues = {
      ...this.props?.initial_values,
      ...this.props?.current_provider
    }
    this.props.initialize({
      ...newValues
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
      this.props.initialize({
        vm_provider_config_name: nextProps.current_provider.vm_provider_config_name,
        vm_provider_name: nextProps.current_provider.vm_provider_name,
        max_instances: nextProps.current_provider.max_instances,

        host: nextProps.current_provider.host,
        username: nextProps.current_provider.username,
        token_name: nextProps.current_provider.token_name,
        token_value: nextProps.current_provider.token_value,
        verify_ssl: nextProps.current_provider.verify_ssl,

        vmid_range_lower: nextProps.current_provider.vmid_range_lower,
        vmid_range_upper: nextProps.current_provider.vmid_range_upper,

        full_clone: nextProps.current_provider.full_clone,
        template_name: nextProps.current_provider.template_name,
        cluster_node_name: nextProps.current_provider.cluster_node_name,
        resource_pool_name: nextProps.current_provider.resource_pool_name,
        storage_pool_name: nextProps.current_provider.storage_pool_name,
        target_node_name: nextProps.current_provider.target_node_name,

        cores: nextProps.current_provider.cores,
        memory: nextProps.current_provider.memory,

        installed_os_type: nextProps.current_provider.installed_os_type,
        startup_script_path: nextProps.current_provider.startup_script_path,
        startup_script: nextProps.current_provider.startup_script,
      });
    }
  }

  cancelButton() {
    this.props.cancel_button(userData)
  }

  submitApi(userData) {
    userData.vm_provider_name = "proxmox"
    this.props.submit_api(userData)
  }

  updateFullClone(event) {
    if (event.target.checked === false) {
      this.props.change('storage_pool_name', '')
    }
  }

  render() {
    const { handleSubmit, t, ProxmoxProviderFormValues } = this.props;

    return (
      <Groups noPadding section="providers" onSubmit={handleSubmit(this.submitApi)}>
        <FormField label="Name">
          <Field type="text"
            name="vm_provider_config_name"
            id="vm_provider_config_name"
            placeholder={t("providers.Example-Proxmox-Config")}
            component={renderField}
            validate={required} required
          />
        </FormField>

          <Field type="number"
            name="max_instances"
            id="max_instances"
            placeholder={t("10")}
            help="kb-24-proxmox-1"
            component={renderField}
            validate={number} required
          />

          <Field type="text"
            name="host"
            id="host"
            placeholder="proxmox.example.com"
            help="kb-24-proxmox-2"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="username"
            id="username"
            placeholder="KasmUser@pve"
            help="kb-24-proxmox-3"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="token_name"
            id="token_name"
            placeholder="KasmToken"
            help="kb-24-proxmox-4"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="token_value"
            id="token_value"
            placeholder=""
            help="kb-24-proxmox-5"
            component={renderPass}
            validate={required} required
          />

          <Field type="checkbox"
            name="verify_ssl"
            id="verify_ssl"
            help="kb-24-proxmox-6"
            checked={this.props.verify_ssl && this.props.current_provider.verify_ssl}
            component={renderToggle}
          />

          <Field type="number"
            name="vmid_range_lower"
            id="vmid_range_lower"
            placeholder="100"
            help="kb-24-proxmox-7"
            component={renderField}
            validate={required} required
          />

          <Field type="number"
            name="vmid_range_upper"
            id="vmid_range_upper"
            placeholder="200"
            help="kb-24-proxmox-8"
            component={renderField}
            validate={required} required
          />

          <Field type="checkbox"
            name="full_clone"
            id="full_clone"
            help="kb-24-proxmox-9"
            checked={this.props.full_clone && this.props.current_provider.full_clone}
            onChange={this.updateFullClone}
            component={renderToggle}
          />

          <Field type="text"
            name="template_name"
            id="template_name"
            placeholder="KasmTemplate"
            help="kb-24-proxmox-10"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="cluster_node_name"
            id="cluster_node_name"
            placeholder="pve"
            help="kb-24-proxmox-11"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="resource_pool_name"
            id="resource_pool_name"
            placeholder="KasmPool"
            help="kb-24-proxmox-12"
            component={renderField}
          />

          {ProxmoxProviderFormValues && ProxmoxProviderFormValues.full_clone &&
          <Field type="text"
            name="storage_pool_name"
            id="storage_pool_name"
            help="kb-24-proxmox-13"
            component={renderField}
          />
          }

          <Field type="text"
            name="target_node_name"
            id="target_node_name"
            placeholder=""
            help="kb-24-proxmox-14"
            component={renderField}
          />

          <Field type="number"
            name="cores"
            id="cores"
            placeholder="2"
            help="kb-24-proxmox-15"
            component={renderField}
            validate={number} required
          />
  
          <Field type="number"
            name="memory"
            id="memory"
            placeholder="2"
            help="kb-24-proxmox-16"
            component={renderField}
            validate={required} required
          />

          <Field type="text"
            name="installed_os_type"
            id="installed_os_type"
            help="kb-24-proxmox-17"
            component={renderSelectField}
            validate={required} required>
              <option>{t("providers.Select")}</option>
              <option value="linux">linux</option>
              <option value="windows">windows</option>
          </Field>

          <Field type="text"
            name="startup_script_path"
            id="startup_script_path"
            placeholder=""
            help="kb-24-proxmox-18"
            component={renderField}
          />

          <Field type="text"
            name="startup_script"
            id="startup_script"
            placeholder="#!/bin/bash&#10;..."
            help="kb-24-proxmox-19"
            component={renderTextArea}
          />

        <FormFooter
          cancelButton={<button className="cancel-button tw-bg-transparent" type="cancel" onClick={() => this.props.cancel_button()}> {this.props.wizard ? t("buttons.Previous") : t("buttons.Cancel")}</button>}
          saveButton={<Button id="save-proxmox-vm" icon="save" type="submit" section="buttons" name={!this.props.wizard ? 'Submit' : this.props.stepCount && this.props.stepCount > 2 ? t("buttons.Next") : t("buttons.Finish")} />}
        />

      </Groups>
    );
  }
}

ProxmoxProviderFormTemplate.propTypes = {
  current_provider: Proptypes.object,
  submit_api: Proptypes.func.isRequired,
  handleSubmit: Proptypes.func,
  cancel_button: Proptypes.func,
  ProxmoxProviderFormValues: Proptypes.object,
};

let ProxmoxProviderFormWithRouter = withRouter(ProxmoxProviderFormTemplate);

let ProxmoxProviderForm = connect(state =>
  ({
    vm_provider_configs: state.vm_provider.vm_provider_configs,
    ProxmoxProviderFormValues: state.form && state.form.VmProviderForm && state.form.VmProviderForm.values ? state.form.VmProviderForm.values : null,
  }), dispatch =>({}))(ProxmoxProviderFormWithRouter);

const ProxmoxProviderFormTranslated = withTranslation('common')(ProxmoxProviderForm)

export default reduxForm({
  form: "VmProviderForm",
})(ProxmoxProviderFormTranslated);
